export default {
    open: "modals.info.open",
    close: "modals.info.close"
}